<div class="accordion-header" [class.open]="isOpen" (click)="toggle()">
  <ng-content select="[accordion-header]"></ng-content>
  <div class="accordion-header-icon-wrapper">
    <ng-content select="[accordion-header-icon-content]"></ng-content>
    @if (!hideIcon) {
      <span class="accordion-header-icon mb-icon mb-icon-down-thin"></span>
    }
  </div>
</div>

@if (isOpen) {
  <div class="accordion-content">
    <ng-content select="[accordion-content]"></ng-content>
  </div>
}
